import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import styles from './Thesis.module.css';
import Eyebrow from '../ui/Eyebrow';

const callouts = [
  { title: 'Data Complexity', desc: 'Existing tools cannot structure it.' },
  { title: 'Transaction Auditability', desc: 'Value demands verifiable records.' },
  { title: 'Compliance Bar', desc: 'Enterprise adoption requires it.' }
];

export default function Thesis() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.15 });

  return (
    <section className={styles.thesis} id="thesis" ref={ref}>
      <motion.div
        className={styles.container}
        initial={{ opacity: 0, y: 16 }}
        animate={isInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.5 }}
      >
        <Eyebrow>INVESTMENT THESIS</Eyebrow>
        <h2 className={styles.heading}>The investment thesis.</h2>
        <div className={styles.body}>
          <p>Infundra targets AI-native B2B opportunities in verticals where the right infrastructure fundamentally changes what is possible. Relevant markets share at least one characteristic: data complexity that existing tools cannot structure, transaction value that demands auditability, or compliance requirements that raise the bar for enterprise adoption.</p>
          <p>Every portfolio company is built on a shared infrastructure foundation. Time-to-market is structurally compressed. Compliance is a platform asset, not a per-product cost. The infrastructure itself is the source of compounding advantage, not deal selection alone.</p>
        </div>
        <div className={styles.callouts}>
          {callouts.map((item, i) => (
            <div key={i} className={styles.callout}>
              <div className={styles.calloutTitle}>{item.title}</div>
              <div className={styles.calloutDesc}>{item.desc}</div>
            </div>
          ))}
        </div>
      </motion.div>
    </section>
  );
}
